'use strict';
import * as $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024 from "./com.raquo.laminar.-Dom-Api$.js";
import * as $j_dev$002echeleb$002escalamigen$002e$002dForm from "./dev.cheleb.scalamigen.-Form.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Ldev_cheleb_scalamigen_Form$$anon$1(label$2, required$2, outer) {
  this.Hh = null;
  this.Hi = false;
  this.Hg = null;
  this.zl = null;
  this.Hh = label$2;
  this.Hi = required$2;
  if ((outer === null)) {
    throw $j_java$002elang$002e$002dObject.$ct_jl_NullPointerException__(new $j_java$002elang$002e$002dObject.$c_jl_NullPointerException());
  }
  this.zl = outer;
  $j_dev$002echeleb$002escalamigen$002e$002dForm.$f_Ldev_cheleb_scalamigen_Form__$init$__V(this);
}
export { $c_Ldev_cheleb_scalamigen_Form$$anon$1 as $c_Ldev_cheleb_scalamigen_Form$$anon$1 };
$p = $c_Ldev_cheleb_scalamigen_Form$$anon$1.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Ldev_cheleb_scalamigen_Form$$anon$1;
/** @constructor */
function $h_Ldev_cheleb_scalamigen_Form$$anon$1() {
}
export { $h_Ldev_cheleb_scalamigen_Form$$anon$1 as $h_Ldev_cheleb_scalamigen_Form$$anon$1 };
$h_Ldev_cheleb_scalamigen_Form$$anon$1.prototype = $p;
$p.dJ = (function() {
  return this.Hg;
});
$p.dt = (function(x$1) {
  this.Hg = x$1;
});
$p.du = (function(x$1) {
});
$p.dx = (function(label, required, factory) {
  return factory.cX(required, label);
});
$p.bt = (function(path, variable, factory, errorBus) {
  return $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$m_Lcom_raquo_laminar_api_package$().d.U().u($j_java$002elang$002e$002dObject.$ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $j_java$002elang$002e$002dObject.$c_sjsr_WrappedVarArgs(), [$j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$m_Lcom_raquo_laminar_api_package$().d.U().u($j_java$002elang$002e$002dObject.$ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $j_java$002elang$002e$002dObject.$c_sjsr_WrappedVarArgs(), [this.zl.dx(this.Hh, this.Hi, factory)])), $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$m_Lcom_raquo_laminar_api_package$().d.U().u($j_java$002elang$002e$002dObject.$ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $j_java$002elang$002e$002dObject.$c_sjsr_WrappedVarArgs(), [this.zl.bt(path, variable, factory, errorBus)]))]));
});
var $d_Ldev_cheleb_scalamigen_Form$$anon$1 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ldev_cheleb_scalamigen_Form$$anon$1, "dev.cheleb.scalamigen.Form$$anon$1", ({
  iX: 1,
  a2: 1
}));
export { $d_Ldev_cheleb_scalamigen_Form$$anon$1 as $d_Ldev_cheleb_scalamigen_Form$$anon$1 };
